import React, { useState } from 'react';

const PALM_TREE_SRC = '/images/palm-tree.png';

const PalmTreeIcon = React.forwardRef(function PalmTreeIcon({ className, ...props }, ref) {
  const [useEmoji, setUseEmoji] = useState(false);

  if (useEmoji) {
    return (
      <span ref={ref} className={className} aria-hidden="true" {...props}>
        🌴
      </span>
    );
  }

  return (
    <img
      ref={ref}
      src={PALM_TREE_SRC}
      alt=""
      className={['object-contain', className].filter(Boolean).join(' ')}
      onError={() => setUseEmoji(true)}
      aria-hidden="true"
      {...props}
    />
  );
});

export default PalmTreeIcon;
